import type { CouponId } from './CouponId.js';
import type { CouponIndex } from './CouponIndex.js';

export { BOARD_PROPS_QP, boardPropsEnum, type QuickPick, quickPickEnum } from './boardProps.js';
export {
  type Bet,
  type BetEvent,
  type Board,
  type BoardType,
  type Coupon,
  couponBoardValidator,
  couponSchema,
  couponValidator,
  indexToOutcomeString,
  isBet,
  isBetArray,
  isBetEvent,
  isOutcome,
  isOutcomeGroup,
  type MOutcomes,
  NO_VALUE_SET,
  numberOfDrawsSchema,
  type NumberOfDrawsValues,
  type Outcome,
  type OutcomeDistribution,
  type OutcomeGroup,
  outcomeSchema,
  outcomeStringToIndex,
  type Reduction,
  type ReductionDistributionOutcome,
  reductionValues,
  type SROW,
  toOutcome,
  toReductionDistributionOutcome,
  type UOutcomes,
} from './Coupon.js';
export { getCouponId } from './CouponId.js';
export { type CouponId, couponIdSchema, type CouponType } from './CouponId.js';
export { couponIndexSchema, getCouponIndex, getCouponIndices } from './CouponIndex.js';
export { type CouponIndex } from './CouponIndex.js';
export type { CouponStatus } from './CouponStatus.js';
export type { ReductionOutcome, ReductionValue } from './Reduction.js';
export {
  isSportkryssValue,
  type SportkryssCoupon,
  type SportkryssNumber,
  type SportkryssValues,
} from './SportkryssCoupon.js';

export type CouponIdentifiers = {
  couponId: CouponId;
  couponIndex: CouponIndex;
};
export type CouponBoardIdentifiers = {
  boardIndex: number;
} & CouponIdentifiers;
